import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import { EBoardSetting } from '../../../../TabDetails/components/TabDetails/types';
import { SegmentBoardOption } from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';

export const onPlay = (
    key: EBoardSetting,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.TUTORIAL_PLAY, {
            name: SegmentBoardOption.TYPE,
            value: key,
        }));
    };
    return action;
};
